import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/user/searchUsers.php';

export default function searchUsers({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}